import React, { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { Card, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Customer from "~/models/Customer";

@observer
class CustomerOrCoCustomerCards extends Component {
  @computed
  get url() {
    const { customerOrCoCustomer } = this.props;
    const { website } = customerOrCoCustomer;

    if (!website || website.startsWith("https://") || website.startsWith("http://")) {
      return website;
    }

    return `http://${website}`;
  }

  @computed
  get hasPhoto() {
    const { customerOrCoCustomer } = this.props;
    const { photoUrl } = customerOrCoCustomer;
    return photoUrl !== null;
  }

  @computed
  get hasLogo() {
    const { customerOrCoCustomer } = this.props;
    const { logoUrl } = customerOrCoCustomer;
    return logoUrl !== null;
  }

  render() {
    const { customerOrCoCustomer, customerLogoOnly, t } = this.props;
    const {
      lastName,
      firstName,
      company,
      website,
      contactPhone,
      cellPhone,
      email,
      photoPathWeb,
      logoPathWeb,
    } = customerOrCoCustomer;

    let usedPhone = null;

    if (contactPhone) {
      usedPhone = contactPhone;
    } else if (cellPhone) {
      usedPhone = cellPhone;
    } else {
      usedPhone = null;
    }

    let photo = null;
    let logo = null;
    if (customerLogoOnly) {
      if (this.hasPhoto && this.hasLogo) {
        if (website) {
          photo = (
            <>
              {this.hasPhoto ? (
                <Card.Content
                  style={this.hasPhoto ? { background: `url(${photoPathWeb}) no-repeat center center` } : null}
                  className={this.hasPhoto ? "card-has-agent-picture" : null}
                />
              ) : null}
            </>
          );
          logo = (
            <a href={this.url} target="_blank" rel="noopener noreferrer" style={{ maxWidth: "5rem" }}>
              <Image src={logoPathWeb} className="card-has-logo" verticalAlign="bottom" floated="right" />
            </a>
          );
        } else {
          photo = (
            <>
              {this.hasPhoto ? (
                <Card.Content
                  style={this.hasPhoto ? { background: `url(${photoPathWeb}) no-repeat center center` } : null}
                  className={this.hasPhoto ? "card-has-agent-picture" : null}
                />
              ) : null}
            </>
          );
          logo = (
            <div style={{ maxWidth: "5rem" }}>
              <Image src={logoPathWeb} className="card-has-logo" verticalAlign="bottom" floated="right" />
            </div>
          );
        }
      } else if (this.hasPhoto && !this.hasLogo) {
        photo = (
          <>
            {this.hasPhoto ? (
              <Card.Content
                style={this.hasPhoto ? { background: `url(${photoPathWeb}) no-repeat center center` } : null}
                className={this.hasPhoto ? "card-has-agent-picture" : null}
              />
            ) : null}
          </>
        );
        logo = null;
      }
    } else if (this.hasPhoto) {
      photo = (
        <>
          {this.hasPhoto ? (
            <Card.Content
              style={this.hasPhoto ? { background: `url(${photoPathWeb}) no-repeat center center` } : null}
              className={this.hasPhoto ? "card-has-agent-picture" : null}
            />
          ) : null}
        </>
      );
    }

    return (
      <Card className="horizontal">
        {photo}
        <Card.Content>
          <Card.Header style={{ fontWeight: "bold", fontSize: "1.28571429em", fontFamily: "Ubuntu, sans-serif" }}>
            {firstName} {lastName}
          </Card.Header>
          <Card.Meta>
            <span>{company}</span>
          </Card.Meta>
          <Card.Description>
            {website ? (
              <>
                <a href={this.url} target="_blank" rel="noopener noreferrer">
                  {t("messages:website")}: {website}
                </a>
                <br />
              </>
            ) : null}
            {usedPhone ? (
              <>
                <a href={`tel:${usedPhone}`}>
                  {t("customerPortal:phone")}: {usedPhone}
                </a>
                <br />
              </>
            ) : null}
            {email ? (
              <a href={`mailto:${email}`}>
                {t("messages:email")}: {email}
              </a>
            ) : null}
            {logo}
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

CustomerOrCoCustomerCards.propTypes = {
  customerOrCoCustomer: PropTypes.instanceOf(Customer),
  customerLogoOnly: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CustomerOrCoCustomerCards);
